/**
 * 左侧目录
 */
export default {
  dbl_menu_folder: 'Folder ',
  dbl_menu_subfolder: 'SubFolder ',
  dbl_menu_menu: 'Menu ',
  dbl_menu_name: 'Name',
  dbl_menu_chinese: 'Chinese ',
  dbl_menu_menu_level: 'Level',
  dbl_menu_enter_dashboard_name: 'Please Enter Dashboard Name',
  dbl_menuenter_dashboard_ch_name: 'Please Enter Dashboard Chinese Name',
  dbl_menu_select_no_data: 'No data available',
  dbl_menu_select_null: 'Menu must be selected',
  dbl_menu_folder_select_null: 'Folder must be selected',
  dbl_menu_user_level_select_null: 'Level must be selected',
  dbl_menu_subfolder_select_null: 'SubFolder must be selected',

  dbl_menu_folder_name_null: 'Folder Name must be filled in，and the  maximum length is 50 chars. ',
  dbl_menu_subfolder_name_null: 'SubFolder Name must be filled in，and the  maximum length is 50 chars. ',
  dbl_menu_menu_name_null: 'Menu Name must be filled in，and the  maximum length is 50 chars. ',
  dbl_menu_dashboard_name_null: 'Dashboard Name must be filled in，and the  maximum length is 50 chars. ',
  dbl_menu_must_contain_less: 'The content must contain less than 50 chars',
  dbl_menu_info_name_err: 'Only Chinese, English and numbers can be input.',
  dbl_menu_dashboard_re_enter: 'Dashboard Name already exists, please re-enter.',
};